import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { environment } from "src/environment/environment";

@Injectable({
    providedIn: 'root',
})

export class GeneraliService {

  private endpoint:string = environment.api_gw + 'integrations/generali';
  
  constructor(
    private router:Router,
    private http:HttpClient
  ) {
    
  }

  GetSituationOptions(caseId:string):Observable<any>{
    return this.http.get(this.endpoint + '/' + caseId + '/situationOptions');
  }

  GetNewDialogOptions(caseId:string):Observable<any>{
    return this.http.get(this.endpoint + '/' + caseId + '/newDialogOptions');
  }

  GetDialogs(caseId:string):Observable<any>{
    return this.http.get(this.endpoint + '/' + caseId + '/dialogs');
  }

  OpenWeb(caseId:string):Observable<any>{
    return this.http.get(this.endpoint + '/' + caseId + '/openweb');
  }
}
